export const SENTRY_ERROR_CAPTURE_STRING = ' - For Sentry';
import * as Sentry from '@sentry/react';

export const captureError = (message: string, extra: any) => {
  if (
    extra.response?.message === 'Request aborted' ||
    extra.response?.code === 'ERR_NETWORK'
  )
    return;
  Sentry.captureMessage(message + SENTRY_ERROR_CAPTURE_STRING, {
    level: 'error',
    extra,
  });
};
